import { createContext, useContext } from 'react'

import { Card, CardContent } from '../../../../components/ui/card'

import type { PropsWithChildren } from '../../../../types'

type StepContext = Omit<Props, 'children'>
type Props = PropsWithChildren<{ isComplete: boolean; step: string }>

const stepContext = createContext<StepContext | null>(null)

function useStep() {
  const context = useContext(stepContext)
  if (!context)
    throw new Error('useStep has to be used inside a Step component.')

  return context
}

function Step({ children, isComplete, step }: Props) {
  return (
    <Card color="dark">
      <CardContent>
        <stepContext.Provider value={{ isComplete, step }}>
          {children}
        </stepContext.Provider>
      </CardContent>
    </Card>
  )
}

export { Step, useStep }
